import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const getRootStyles = (visibleSlides: number): SxProps<Theme> => ({
	display: { xs: 'flex', md: 'grid' },
	flexDirection: 'column',
	gridTemplateColumns: {
		md:
			visibleSlides === 2
				? 'minmax(0, 1fr) 12px minmax(0, 1fr)'
				: 'minmax(0, 1fr) 12px minmax(0, 1fr) 12px minmax(0, 1fr)',
	},
	gap: {
		xs: '10px',
		md: '20px',
	},
});

export const cardSubtotalButtonDisabled: SxProps<Theme> = (theme) => ({
	border: `2px solid ${theme.palette.grey[100]}`,
});

export const cardFirstStyle: SxProps<Theme> = (theme) => ({
	borderRadius: '3px',
	backgroundColor: `${theme.palette.grey[50]}`,
	borderColor: `${theme.palette.grey[50]}`,
	borderWidth: 1,
	height: '100%',
});

export const cardBuyTogetherText: SxProps<Theme> = (theme) => ({
	color: `${theme.palette.grey[500]}`,
	textAlign: 'center',
});
export const cardPriceValue: SxProps<Theme> = (theme) => ({
	fontSize: '21px',
	fontWeight: OpenSansFontWeights.bold,
	color: `${theme.palette.grey[500]}`,
	display: 'flex',
	alignItems: 'center',
});

export const cardTotalCartPriceValue: SxProps<Theme> = (theme) => ({
	fontSize: '2.25rem',
	fontWeight: OpenSansFontWeights.bold,
	color: `${theme.palette.grey[500]}`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	margin: '20px 0 10px',
});

export const cartDesktopImageSx = (slidesQty = 0) => ({
	alignSelf: 'center',
	width: '100%',
	maxWidth: {
		md: slidesQty === 2 ? '390px' : '402px',
		lg: slidesQty === 2 ? '350px' : '313px',
	},
	aspectRatio: '1 / 1',
});

export const styles = {
	cardRestStyle: {
		borderRadius: '3px',
		backgroundColor: 'white',
		borderColor: 'white',
		borderWidth: 1,
		height: '100%',
	},
	buyTogether: {
		mt: { xs: '10px', md: '20px' },
		display: 'flex',
		flexDirection: { xs: 'column', lg: 'row' },
		gap: { xs: '15px', md: '20px' },
	},
	buyTogetherPaper: {
		width: '100%',
		p: { xs: '10px 10px 15px', md: '20px' },
	},
	cardSubtotalButtonActive: { border: '2px solid', p: '10px 20px' },
	cardLoopItemContainer: {
		p: '15px !important',
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		height: '100%',
	},
	cardImageDesktop: {
		aspectRatio: '1 / 1',
		objectFit: 'cover',
	},
	cardTitleRow: {
		display: 'flex',
		p: '5px 0',
		gap: '5px',
		alignItems: {
			md: 'start',
		},
		justifyItems: {
			md: 'start',
		},
		flex: 1,
	},
	cardCheckboxElement: {
		p: '0',
		'& input': {
			width: '40px',
			height: '40px',
		},
	},
	cardNameDescriptionValue: {
		color: 'grey.500',
		display: '-webkit-box',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	cardPlusIconItems: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		pb: '103px',
	},
	cardPlusIcon: {
		fontSize: '12px',
	},
	cardAddRemoveContainer: {
		display: {
			xs: 'flex',
		},
		gridColumn: {
			xs: '1 / span 2',
		},
		position: { xl: 'absolute' },
		right: { xl: '16px' },
		bottom: { xl: '16px' },
	},
	cardLoopContainer: {
		position: 'relative',
		height: '100%',
	},
	cardMobileHeaderContainer: {
		display: 'flex',
		gap: '10px',
		justifyContent: 'space-between',
	},
	cardMobileHeader: {
		display: 'flex',
		gap: '10px',
	},
	cardMobileImage: {
		alignSelf: 'center',
		width: {
			sm: '60px',
		},
		height: {
			sm: '60px',
		},
	},
	cardMobileName: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
	cardDesktopFooter: {
		display: 'flex',
		flexDirection: { md: 'column', xl: 'row' },
		alignItems: { md: 'start', xl: 'center' },
		justifyContent: 'space-between',
		gap: '10px',
		flex: 1,
	},
	cardNumberInput: {
		width: { xs: '100%', xl: 'fit-content' },
		maxWidth: { xl: '130px' },
	},
	cardControlContainer: { display: 'flex', margin: '0' },
	cardControlQtyDiscount: { display: 'flex', flexDirection: 'column' },
	cardControlQtyDiscountText: {
		color: 'success.main',
		fontWeight: OpenSansFontWeights.bold,
	},
	cardControlQtyDiscountTextRest: { textDecoration: 'line-through' },
	cardBuyTogetherContainer: {
		p: { xs: '0px 20px !important', md: '20px !important' },
		textAlign: 'center',
		border: 'none',
		width: '100%',
		height: '100%',
		alignContent: 'center',
	},
	cardBuyTogetherSubtotal: {
		display: 'flex',
		justifyContent: 'center',
		margin: '20px 0',
	},
};

export const cardTotalPriceContainerSx = (visibleSlides: number): SxProps<Theme> => ({
	display: { lg: 'flex' },
	alignItems: { lg: 'center' },
	minWidth: { lg: '245px' },
	maxWidth: { lg: visibleSlides === 2 ? '30%' : '20%' },
	border: 'none',
	width: '100%',
});
